import type { Styles } from "../../../styled-system/css";

export const selectButtonStyle: Styles = {
  display: "flex",
  alignItems: "center",
  gap: "4px",
  bg: "white",
  rounded: "full",
  py: "8px",
  px: "16px",
  fontSize: "14px",
  border: "2px solid",
  borderColor: "border.primary",
  color: "text.primary",
  flexShrink: 0,
  "& svg": {
    width: "18px",
    height: "18px",
  },
  "&.active": {
    color: "text.accentPrimary",
    borderColor: "border.accentPrimary",
    bg: "surface.accentPrimaryLight",
  },
};
